module.exports = __webpack_public_path__ + "img/des3.1c2a7d4f.png";